import { render, staticRenderFns } from "./appFeedback.vue?vue&type=template&id=194a82e4&"
import script from "./appFeedback.vue?vue&type=script&lang=js&"
export * from "./appFeedback.vue?vue&type=script&lang=js&"
import style0 from "./appFeedback.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports